
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { initSentry } from "./lib/sentry.ts";

// Initialize Sentry as early as possible
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
